import InvestorAutologin from './InvestorAutologin';

export default InvestorAutologin;
